import { Component } from '@angular/core'
// import { ButtonComponent } from './components/partials/button/button.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'Kinnil2023'
}
